<div class="skl-ai-config-history" aria-busy="true" aria-label="Loading assessment job history">
  <app-skeleton width="330px" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

  <div class="skl-card">
    <div class="skl-card__body">
      <div class="skl-table-wrap">
        <div class="table-responsive">
          <table class="skl-table">
            <colgroup>
              <col style="width: 8%">
              <col style="width: 22%">
              <col style="width: 8%">
              <col style="width: 10%">
              <col style="width: 12%">
              <col style="width: 12%">
              <col style="width: 8%">
              <col style="width: 10%">
              <col style="width: 10%">
            </colgroup>
            <thead>
              <tr>
                @for (col of tableCols; track col) {
                  <th>
                    <app-skeleton [width]="col === 1 ? '42%' : col === 2 ? '74%' : col === 3 ? '52%' : col === 4 ? '46%' : col === 5 ? '62%' : col === 6 ? '48%' : col === 7 ? '42%' : col === 8 ? '36%' : '40%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of tableRows; track row) {
                <tr>
                  @for (col of tableCols; track col) {
                    <td [class.skl-cell--top]="col === 8 || col === 9">
                      @if (col === 4) {
                        <app-skeleton width="82px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      } @else if (col === 8) {
                        <div class="skl-token-stack">
                          <app-skeleton width="70px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="70px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="72px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                        </div>
                      } @else if (col === 9) {
                        <div class="skl-details-stack">
                          @if (row % 3 !== 0) {
                            <app-skeleton width="112px" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
                          }
                          <app-skeleton [width]="row % 2 === 0 ? '72%' : '58%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                          @if (row % 2 === 0) {
                            <app-skeleton width="46%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                          }
                        </div>
                      } @else {
                        <app-skeleton [width]="col === 1 ? (row % 2 === 0 ? '40%' : '32%') : col === 2 ? (row % 2 === 0 ? '88%' : '80%') : col === 3 ? (row % 2 === 0 ? '58%' : '46%') : col === 5 ? (row % 2 === 0 ? '74%' : '62%') : col === 6 ? (row % 2 === 0 ? '54%' : '44%') : col === 7 ? (row % 2 === 0 ? '46%' : '38%') : '52%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="skl-pagination">
        <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        <div class="skl-pagination-buttons">
          @for (btn of [1, 2, 3, 4]; track btn) {
            <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
          }
        </div>
      </div>
    </div>
  </div>
</div>